import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TopicManagementComponent } from './topic-management/topic-management.component';
import { EditTopicComponent } from './edit-topic/edit-topic.component';

const routes: Routes = [
  { path: '', component: TopicManagementComponent },
  { path: 'new', component: EditTopicComponent },
  { path: ':id', component: EditTopicComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TopicManagementRoutingModule {}
